import { useLocation, useNavigate, useParams } from 'react-router'

import { useEntityProfileTabsActiveTab } from '../../../../Entity'

import { getApplicantProfileTabUrl } from './useApplicantProfileTabsActiveTab.utils'

export function useApplicantProfileTabsActiveTab({
  applicantData,
  preparedTabs,
}) {
  const navigate = useNavigate()

  const location = useLocation()

  const { applicantId } = useParams()

  function getTabUrl(tab) {
    return getApplicantProfileTabUrl({ applicantId, tab })
  }

  const { activeTabId } = useEntityProfileTabsActiveTab({
    getTabUrl,
    isEntityLoaded: Boolean(applicantData),
    preparedTabs,
  })

  function handleSetActiveTab(tabId) {
    navigate(
      {
        hash: location.hash,
        pathname: getTabUrl(tabId),
        search: location.search,
      },
      { replace: true }
    )
  }

  return {
    activeTabId,
    handleSetActiveTab,
  }
}
